module.exports = __webpack_public_path__ + "img/2-5.146da4e5.svg";